import { Icon } from '@iconify/react';
import { useNavigate } from "react-router-dom";
import { Button, ButtonVariant } from "@repo/design-system/components/ui";

import "./PageNotFound.scss";

export const PageNotFound = () => {

    const navigate = useNavigate();

    const handleGoToDashboard = () => {
        navigate("/")
    };

    return (
        <div className="notfound-container">
            <div className="bg-blob bg-blob-1"></div>
            <div className="bg-blob bg-blob-2"></div>

            <div className="notfound-wrapper">

                {/* Student Portal Illustration */}
                <div className="illustration-wrapper">
                    <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg" className="student-svg">

                        {/* Floating: Graduation Cap (top-left) */}
                        <g className="float-el el-cap">
                            <polygon points="52,40 26,55 78,55" fill="var(--accent-primary)" opacity="0.75" />
                            <rect x="26" y="55" width="52" height="10" rx="2" fill="var(--accent-primary)" opacity="0.75" />
                            <line x1="74" y1="55" x2="83" y2="76" stroke="var(--accent-primary)" strokeWidth="2.5" opacity="0.75" />
                            <circle cx="83" cy="79" r="4" fill="var(--accent-primary)" opacity="0.75" />
                        </g>

                        {/* Floating: Open Book (top-right) */}
                        <g className="float-el el-book">
                            <rect x="308" y="25" width="68" height="50" rx="5" fill="#4A90D9" opacity="0.6" />
                            <rect x="308" y="25" width="7" height="50" rx="4" fill="#2E6DA4" opacity="0.6" />
                            <rect x="338" y="25" width="2" height="50" fill="#2E6DA4" opacity="0.4" />
                            <line x1="318" y1="41" x2="335" y2="41" stroke="white" strokeWidth="1.5" opacity="0.7" />
                            <line x1="318" y1="50" x2="335" y2="50" stroke="white" strokeWidth="1.5" opacity="0.7" />
                            <line x1="318" y1="59" x2="330" y2="59" stroke="white" strokeWidth="1.5" opacity="0.7" />
                            <line x1="342" y1="41" x2="368" y2="41" stroke="white" strokeWidth="1.5" opacity="0.7" />
                            <line x1="342" y1="50" x2="368" y2="50" stroke="white" strokeWidth="1.5" opacity="0.7" />
                            <line x1="342" y1="59" x2="358" y2="59" stroke="white" strokeWidth="1.5" opacity="0.7" />
                        </g>

                        {/* Floating: Scholarship Scroll (left side) */}
                        <g className="float-el el-scroll">
                            <rect x="16" y="152" width="56" height="42" rx="3" fill="#9B59B6" opacity="0.6" />
                            <rect x="9" y="152" width="13" height="42" rx="7" fill="#7D3C98" opacity="0.6" />
                            <rect x="65" y="152" width="13" height="42" rx="7" fill="#7D3C98" opacity="0.6" />
                            <circle cx="41" cy="163" r="5" fill="#FFD700" opacity="0.85" />
                            <line x1="26" y1="173" x2="63" y2="173" stroke="white" strokeWidth="1.5" opacity="0.6" />
                            <line x1="26" y1="181" x2="63" y2="181" stroke="white" strokeWidth="1.5" opacity="0.6" />
                            <line x1="30" y1="189" x2="56" y2="189" stroke="white" strokeWidth="1.5" opacity="0.6" />
                        </g>

                        {/* Floating: Attendance Calendar (bottom-right) */}
                        <g className="float-el el-calendar">
                            <rect x="312" y="198" width="66" height="65" rx="8" fill="#F5A623" opacity="0.6" />
                            <rect x="312" y="198" width="66" height="20" rx="8" fill="#E8941A" opacity="0.6" />
                            <rect x="312" y="210" width="66" height="8" fill="#E8941A" opacity="0.6" />
                            <circle cx="328" cy="231" r="4.5" fill="white" opacity="0.8" />
                            <circle cx="345" cy="231" r="4.5" fill="white" opacity="0.8" />
                            <circle cx="362" cy="231" r="4.5" fill="white" opacity="0.8" />
                            <circle cx="328" cy="249" r="4.5" fill="#4CAF50" />
                            <circle cx="345" cy="249" r="4.5" fill="#4CAF50" />
                            <circle cx="362" cy="249" r="4.5" fill="#E74C3C" />
                        </g>

                        {/* Floating: AI Chatbot Bubble (top-center) */}
                        <g className="float-el el-chat">
                            <rect x="150" y="12" width="100" height="48" rx="15" fill="var(--accent-primary)" opacity="0.1" />
                            <rect x="150" y="12" width="100" height="48" rx="15" stroke="var(--accent-primary)" strokeWidth="1.5" opacity="0.4" />
                            <polygon points="168,60 182,60 173,74" fill="var(--accent-primary)" opacity="0.35" />
                            <circle className="dot-1" cx="180" cy="36" r="5.5" fill="var(--accent-primary)" opacity="0.55" />
                            <circle className="dot-2" cx="200" cy="36" r="5.5" fill="var(--accent-primary)" opacity="0.55" />
                            <circle className="dot-3" cx="220" cy="36" r="5.5" fill="var(--accent-primary)" opacity="0.55" />
                        </g>

                        {/* Floating: College Building (right side) */}
                        <g className="float-el el-college">
                            <rect x="295" y="143" width="76" height="57" fill="#EAE0F8" opacity="0.75" />
                            <polygon points="295,143 333,114 371,143" fill="#D5C8EA" opacity="0.75" />
                            <rect x="303" y="153" width="14" height="17" rx="2" fill="#4A90D9" opacity="0.65" />
                            <rect x="324" y="153" width="14" height="17" rx="2" fill="#4A90D9" opacity="0.65" />
                            <rect x="347" y="153" width="14" height="17" rx="2" fill="#4A90D9" opacity="0.65" />
                            <rect x="319" y="172" width="26" height="28" rx="2" fill="#8B6914" opacity="0.7" />
                            <circle cx="339" cy="187" r="2.5" fill="#FFD700" opacity="0.85" />
                            <rect x="291" y="143" width="6" height="57" fill="#C5B8DC" opacity="0.75" />
                            <rect x="369" y="143" width="6" height="57" fill="#C5B8DC" opacity="0.75" />
                            <line x1="333" y1="97" x2="333" y2="114" stroke="#aaa" strokeWidth="1.5" />
                            <polygon points="333,97 350,105 333,113" fill="#E74C3C" opacity="0.7" />
                        </g>

                        {/* Sparkle Stars */}
                        <path className="float-el el-star1" d="M118 20 L120 14 L122 20 L128 22 L122 24 L120 30 L118 24 L112 22 Z" fill="var(--accent-primary)" opacity="0.28" />
                        <path className="float-el el-star2" d="M278 268 L280 263 L282 268 L287 270 L282 272 L280 277 L278 272 L273 270 Z" fill="#F5A623" opacity="0.38" />
                        <path className="float-el el-star3" d="M86 262 L88 257 L90 262 L95 264 L90 266 L88 271 L86 266 L81 264 Z" fill="#9B59B6" opacity="0.32" />

                        {/* ===== Student Character ===== */}

                        {/* Ground shadow */}
                        <ellipse cx="200" cy="293" rx="54" ry="7" fill="rgba(0,0,0,0.07)" />

                        {/* Legs */}
                        <rect x="183" y="250" width="15" height="37" rx="7" fill="#3D5A80" />
                        <rect x="202" y="250" width="15" height="37" rx="7" fill="#3D5A80" />

                        {/* Shoes */}
                        <ellipse cx="190" cy="287" rx="15" ry="6" fill="#233E59" />
                        <ellipse cx="210" cy="287" rx="15" ry="6" fill="#233E59" />

                        {/* Body */}
                        <rect x="172" y="190" width="56" height="64" rx="10" fill="#4A90D9" />

                        {/* Shirt collar V-line */}
                        <path d="M172 202 L185 190 L200 199 L215 190 L228 202" stroke="rgba(255,255,255,0.22)" strokeWidth="1.5" fill="none" />

                        {/* Student ID badge on shirt */}
                        <rect x="186" y="208" width="28" height="36" rx="3" fill="white" opacity="0.22" />
                        <circle cx="200" cy="219" r="6" fill="rgba(255,255,255,0.45)" />
                        <line x1="189" y1="229" x2="211" y2="229" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5" />
                        <line x1="189" y1="236" x2="211" y2="236" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5" />

                        {/* Left arm raised in confusion */}
                        <path d="M172 208 Q148 197 135 174" stroke="#F5D5B8" strokeWidth="15" strokeLinecap="round" fill="none" />
                        <circle cx="132" cy="170" r="9" fill="#F5D5B8" />

                        {/* Right arm raised in confusion */}
                        <path d="M228 208 Q252 197 265 174" stroke="#F5D5B8" strokeWidth="15" strokeLinecap="round" fill="none" />
                        <circle cx="268" cy="170" r="9" fill="#F5D5B8" />

                        {/* Neck */}
                        <rect x="191" y="179" width="18" height="16" rx="6" fill="#F5D5B8" />

                        {/* Head */}
                        <circle cx="200" cy="156" r="35" fill="#F5D5B8" />

                        {/* Hair */}
                        <path d="M165 149 Q169 122 200 120 Q231 122 235 149 Q231 132 200 130 Q169 132 165 149Z" fill="#4A3728" />
                        <path d="M165 149 Q162 160 164 171" stroke="#4A3728" strokeWidth="8" strokeLinecap="round" fill="none" />
                        <path d="M235 149 Q238 160 236 171" stroke="#4A3728" strokeWidth="8" strokeLinecap="round" fill="none" />

                        {/* Left eye – looking up/sideways confused */}
                        <circle cx="187" cy="156" r="6.5" fill="white" />
                        <circle cx="188" cy="154" r="4" fill="#3D2B1F" />
                        <circle cx="189" cy="153" r="1.4" fill="white" />

                        {/* Right eye */}
                        <circle cx="213" cy="156" r="6.5" fill="white" />
                        <circle cx="212" cy="154" r="4" fill="#3D2B1F" />
                        <circle cx="213" cy="153" r="1.4" fill="white" />

                        {/* Eyebrows – raised in confusion */}
                        <path d="M180 145 Q187 140 194 143" stroke="#4A3728" strokeWidth="2.8" strokeLinecap="round" fill="none" />
                        <path d="M206 143 Q213 140 220 145" stroke="#4A3728" strokeWidth="2.8" strokeLinecap="round" fill="none" />

                        {/* Mouth – confused open */}
                        <path d="M192 172 Q200 168 208 172" stroke="#B8866A" strokeWidth="2.8" strokeLinecap="round" fill="none" />

                        {/* Graduation Cap */}
                        <rect x="165" y="127" width="70" height="13" rx="3" fill="#233E59" />
                        <polygon points="200,110 165,127 235,127" fill="#233E59" />
                        <line x1="231" y1="127" x2="242" y2="156" stroke="#F5A623" strokeWidth="2.5" />
                        <circle cx="242" cy="160" r="5.5" fill="#F5A623" />

                        {/* Floating question marks near the character */}
                        <text x="143" y="118" fill="var(--accent-primary)" fontSize="26" opacity="0.22" fontWeight="bold">?</text>
                        <text x="248" y="126" fill="var(--accent-primary)" fontSize="19" opacity="0.18" fontWeight="bold">?</text>
                    </svg>
                </div>

                <div className="content-section">
                    <h1 className="error-code">404</h1>
                    <p className="error-title">Page Not Found</p>
                    <p className="error-description">
                        Looks like this page went on a study break!
                        Let's get you back to your dashboard.
                    </p>
                </div>

                <div className="actions">
                    <Button leftIcon="mdi:home-outline" onClick={handleGoToDashboard}>
                        Go to Dashboard
                    </Button>
                    <Button leftIcon="mdi:arrow-left" variant={ButtonVariant.OUTLINE}
                        onClick={() => window.history.back()}>
                        Go Back
                    </Button>
                </div>

                <div className="divider"></div>

                {/* <div className="suggestions">
                    <div className="suggestion-item">
                        <Icon icon="mdi:school-outline" className="suggestion-icon" />
                        <p className="suggestion-title">Browse Colleges</p>
                        <p className="suggestion-desc">Explore affiliated colleges and programs</p>
                    </div>
                    <div className="suggestion-item">
                        <Icon icon="mdi:file-certificate-outline" className="suggestion-icon" />
                        <p className="suggestion-title">View Scholarships</p>
                        <p className="suggestion-desc">Find and apply for available scholarships</p>
                    </div>
                    <div className="suggestion-item">
                        <Icon icon="mdi:robot-outline" className="suggestion-icon" />
                        <p className="suggestion-title">Ask AI Assistant</p>
                        <p className="suggestion-desc">Get instant help from our smart chatbot</p>
                    </div>
                </div> */}
            </div>
        </div>
    );
};
